import { GraphicElement } from './GraphicElement';
import { Position } from '../Transform/Position';
import { Size } from '../Size';
import { Scale } from '../Transform/Scale';
import { Rotation } from '../Transform/Rotation';
import { Media } from '../Media';
import { Base64 } from '../Base64';
export class Image extends GraphicElement {
    constructor(
        engine,
        content,
        position = new Position(),
        uuid = GraphicElement.generateUUID(),
        size = new Size(),
        options = {},
        scale = new Scale(),
        rotation = new Rotation()
    ) {
        super(engine, uuid, position, size, scale, rotation, options);
        this.type = 'Image';
        this.clipPath = null;
        this._content = content;
        // Vérifier que content existe et a la méthode duplicate
        this.originalContent = content?.duplicate ? content.duplicate() : content;
    }
    static hydrate(data) {
        const image = new Image(
            data._engine,
            data._content,
            new Position(),
            data._uuid,
            new Size(data.originSize._width, data.originSize._height),
            data.options
        );
        image.content = Media.fromAdress(data._content._mediaAddress);
        image.originalContent = Media.fromAdress(data.originalContent._mediaAddress);
        image.transform.resize(new Scale(data.transform._scale._scaleX, data.transform._scale._scaleY));
        image.transform.rotate(data.transform._rotation._angle);
        image.isInsideTheme = data._isInsideTheme;
        image.transform.groupId = data.transform.groupId;
        image.clipPath = data.clipPath;
        if (data.transform._localPos) {
            image.transform.localPos = new Position(data.transform._localPos._x, data.transform._localPos._y);
        } else {
            image.transform.moveTo(new Position(data.transform._pos._x, data.transform._pos._y));
        }
        image.visible = data.visible;
        return image;
    }
    update(content, options, scale, size) {
        super.update(content, options, scale);
        if (content) {
            this.content = content;
            this.originalContent = this._content.duplicate();
        }
        if (size) {
            this.originSize = size;
        }
    }
    get content() {
        return this._content;
    }
    set content(content) {
        if (!(content instanceof Media) && !(content instanceof Base64)) {
            throw new Error('Update image: Base64 or Media expected');
        }
        if (content instanceof Media) {
            this._content = content;
        } else if (content instanceof Base64) {
            const media = Media.fromContent(content.value);
            this._content = media;
        }
        if (this.originalContent === null) {
            this.originalContent = this._content.duplicate();
        }
    }
}
